import { render, staticRenderFns } from "./ConfigurationEditModal.vue?vue&type=template&id=22fc3fce"
import script from "./ConfigurationEditModal.vue?vue&type=script&lang=js"
export * from "./ConfigurationEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports